import { useSyncExternalStore } from 'react';

import { closeModal, getModalsSnapshot, subscribeModals } from './open-modal';

/**
 * Renders the modals opened via `openModal` inside the app's React tree, so
 * they share its context providers (Router, Mixpanel, …) and the same Radix
 * layer tree. Mounted once, near the app shell.
 */
export const ModalOutlet = () => {
  const modals = useSyncExternalStore(subscribeModals, getModalsSnapshot, getModalsSnapshot);

  return (
    <>
      {modals.map(({ id, Modal, options }) => {
        const handleClose = () => closeModal(id);

        return <Modal key={id} {...options} onClose={handleClose} onCancel={handleClose} />;
      })}
    </>
  );
};
